import createEditModeUrl from './createEditModeUrl';
import createLocalizedUrl from './createLocalizedUrl';

/**
 *
 * @param {FrontendContext} context
 * @return { (urlValue: string) => string } - the returned function
 */
function getCreateUrl(context) {
  let createUrl;
  if ('isEditMode' in context && context.isEditMode) {
    createUrl = (urlValue) => createEditModeUrl(urlValue, context.query);
  } else if (context.locale && context.locale !== context.defaultLanguage) {
    createUrl = (urlValue) => createLocalizedUrl(urlValue, context.locale);
  } else {
    createUrl = (urlValue) => urlValue;
  }
  return createUrl;
}

export default getCreateUrl;
